import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPortfolioItem } from "../portfoliioItemModal";

export const getAllPortfolioItems = createAsyncThunk(
  "PortfolioItem/FindAllPortfolioItem",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PortfolioItem/FindAllPortfolioItem`,
        {
          PortfolioItemsTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PortfolioItem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createPortfolioItems = createAsyncThunk(
  "PortfolioItem/InsertPortfolioItem",
  async (PortfolioItemsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PortfolioItem/InsertPortfolioItem`,
        PortfolioItemsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating PortfolioItem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updatePortfolioItems = createAsyncThunk(
  "PortfolioItem/UpdatePortfolioItem",
  async (PortfolioItemsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PortfolioItem/UpdatePortfolioItem`,
        PortfolioItemsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating PortfolioItem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePortfolioItems = createAsyncThunk(
  "PortfolioItem/DeletePortfolioItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PortfolioItem/DeletePortfolioItem`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting PortfolioItem :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getPortfolioItemsByID = createAsyncThunk(
  "PortfolioItem/FindByIDPortfolioItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PortfolioItem/FindByIDPortfolioItem`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceID: result?.ServiceID ?? "",
        ServiceTitle: result?.ServiceTitle ?? "",
        Title: result?.Title ?? "",
        Description: result?.Description ?? "",
        PageContent: result?.PageContent ?? "",
        PortfolioBannerImage: result?.PortfolioBannerImage ?? "",
        CardImage: result?.CardImage ?? "",
        URL: result?.URL ?? "",
        IsActive: result.IsActive ? 1 : 2,
      } as IPortfolioItem;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching PortfolioItem :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActivePortfolioItems = createAsyncThunk(
  "PortfolioItem/FindAllActivePortfolioItem",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PortfolioItem/FindAllActivePortfolioItem`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PortfolioItem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactivePortfolioItems = createAsyncThunk(
  "PortfolioItem/ActiveInActivePortfolioItem",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PortfolioItem/ActiveInActivePortfolioItem`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive PortfolioItem :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const PortfolioItemsDetailsImageUpload = createAsyncThunk(
  "PortfolioItem/PortfolioItemImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PortfolioItem/PortfolioItemImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload PortfolioItem Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
